import React from 'react';

import { SALE_TYPES } from '../../../services/utils/campaign';
import { isPreviewingCampaign } from '../../../services/utils/page';
import Tab from './Tab';
import styles from './Tabs.module.css';

const TABS = {
  SEASON: {
    id: 'add-ons',
    name: 'Add-Ons',
    icon: 'fa-box',
  },
  EDIT: {
    id: 'edit',
    name: 'Edit Sale',
    icon: 'fa-tags',
  },
  FLASH: {
    id: 'flash-sales',
    name: 'Flash Sales',
    icon: 'fa-tags',
  },
  SHOP: {
    id: 'shop',
    name: 'The Shop',
    icon: 'fa-store-alt',
  },
  SOCIAL: {
    id: 'social',
    icon: 'fa-users',
  },
  SOCIAL_EDIT: {
    id: 'social-edit',
    name: 'My Cart',
    icon: 'fa-tags',
  },
};

const getCampaign = (activeCampaign, displaySocialCart) => {
  if (activeCampaign && isPreviewingCampaign) return TABS[activeCampaign.type];
  if (activeCampaign && activeCampaign.type === SALE_TYPES.SEASON) return TABS.SEASON;
  if (activeCampaign && activeCampaign.type === SALE_TYPES.EDIT) {
    if (displaySocialCart) {
      return TABS.SOCIAL_EDIT;
    }
    return TABS.EDIT;
  }

  return TABS.FLASH;
};

const getSocialTabName = (teamCount) => {
  if (teamCount > 1) return `${teamCount} Friends' Carts`;
  if (teamCount === 1) return `1 Friend's Cart`;
  return "Friends' Carts";
};

const getSecondCampaign = (displaySocialCart, teamCount) => {
  if (displaySocialCart) {
    return {
      ...TABS.SOCIAL,
      name: getSocialTabName(teamCount),
    };
  }
  return TABS.SHOP;
};

const Tabs = ({
  activeCampaign,
  activeTab,
  setActiveTab,
  saleItemsCount,
  shopItemsCount,
  teamCount,
  displaySocialCart,
}) => {
  const campaign = getCampaign(activeCampaign, displaySocialCart);
  const secondCampaign = getSecondCampaign(displaySocialCart, teamCount);

  return (
    <div className={styles.container}>
      <Tab
        // TODO change this from spreading to normal props
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...campaign}
        active={activeTab === 0}
        quantity={saleItemsCount}
        onClick={() => setActiveTab(0)}
      />
      <Tab
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...secondCampaign}
        active={activeTab === 1}
        quantity={displaySocialCart ? null : shopItemsCount}
        onClick={() => setActiveTab(1)}
      />
    </div>
  );
};

export default Tabs;
